import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const outgoingCredentialsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "applinks-outgoing-credentials-modal" */ './index'),
	),
	getPreloadProps: () => ({}),
});
